import { render, staticRenderFns } from "./UpdatePackage.vue?vue&type=template&id=4e4fb866&scoped=true"
import script from "./UpdatePackage.vue?vue&type=script&lang=js"
export * from "./UpdatePackage.vue?vue&type=script&lang=js"
import style0 from "./UpdatePackage.vue?vue&type=style&index=0&id=4e4fb866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fb866",
  null
  
)

export default component.exports